<div class="tournaments-page">
  <header class="page-header">
    <h1>Tournaments</h1>
  </header>

  <ng-container *ngIf="!loading">
    <ng-container *ngIf="tournaments.length > 0; else emptyState">
      <ul class="tournament-grid">
        <li
          *ngFor="let t of tournaments"
          class="tournament-card"
          data-testid="tournament-card"
          (click)="goToDetail(t.id)">
          <div class="tournament-card-header">
            <h2>{{ t.name }}</h2>
            <span class="badge">{{ t.registered_teams_count }} / {{ t.max_teams }}</span>
          </div>
          <p class="tournament-card-meta">
            {{ t.club_name }} · {{ t.start_date | date:'mediumDate' }}
            · €{{ t.admission_price }}
          </p>
        </li>
      </ul>
    </ng-container>

    <ng-template #emptyState>
      <div class="empty-state" data-testid="empty-state">
        <div class="empty-state-icon">
          <lucide-icon name="trophy" [size]="32"></lucide-icon>
        </div>
        <h2>No upcoming tournaments</h2>
        <p>Check back soon — clubs will be announcing tournaments here.</p>
      </div>
    </ng-template>
  </ng-container>

  <button
    *ngIf="isAdmin"
    class="fab-create"
    data-testid="create-fab"
    (click)="goToCreate()"
    aria-label="Create tournament">
    <lucide-icon name="plus" [size]="22"></lucide-icon>
  </button>
</div>
